module.exports = __webpack_public_path__ + "static/media/app_store_badge_us_white@3x.6a93de3c.png";